<div class=" mt-4">
  <section>
    <div class="scrollmenu">
      <a routerLinkActive = "active" class="active menu" [routerLink]="['/pos/businessinfo']"> Business-info </a>
      <a [routerLink]="['/pos/customer/manage']"> Customer </a>
      <a [routerLink]="['/pos/employee/manage']"> Employee </a>
      <a [routerLink]="['/pos/orders/manage']"> Orders </a>
      <a [routerLink]="['/pos/taxfee/manage']"> Tax-Fee </a>
      <a [routerLink]="['/pos/category/manage']"> Item-Category </a>
      <a [routerLink]="['/pos/item/manage']">Items </a>
      <a [routerLink]="['/pos/businesshour/manage']"> Business-Hours </a>



      <!-- <a [routerLink]="['/pos/order/new']"> Order </a>
      <a [routerLink]="['/pos/orderreceipt/new']"> Order Receipt </a>
      <a [routerLink]="['/pos/payment/new']"> Payment </a>
      <a [routerLink]="['/pos/paymentrecipt/new']"> Payment Receipt </a>
      <a [routerLink]="['/pos/tip/new']"> Tips </a> -->
      
        <!--  <a [routerLink]="['/pos/orderregister']"> Order Register </a>  -->
        <!--  <a [routerLink]="['/pos/ordertype/new']"> Order Type </a> -->
        <!--   <a [routerLink]="['/pos/tender/new']">  Tender </a>  -->
  </div>

  </section>
  <section class="mt-2">
      <div class="">
          <div class="row">
              <div class="col-md-7">
                  <div class="card-1">
                      <div class="row">
                          <div class="col-md-12">
                              <!-- <div class="text-center mb-5">
                                  <img src="assets/img/new/view-trans.svg" />
                              </div> -->
                              <div class="text-center">
                                                                
                                  <div class="col-md-12 " *ngIf="isNewBusinessinfo">
                                    <a  class="view-h gary-t  ">Business Info</a>
                                  </div>
                                  <div class="col-md-12 " *ngIf="isUpdateBusinessinfo">
                                    <a  class="view-h gary-t  ">Lets Update Business Info</a>
                                  </div>
                                  <div class="col-md-12 " *ngIf="businessviewinfo">
                                    <a  class="view-h gary-t  ">View Business Info</a>
                                  </div>

                              </div>

                              <div class="py-3">
                                <form #fnebusiness="ngForm">
                                  <div class="row mx-0">
                                    <div class="col-md-12" *ngIf="isNewBusinessinfo">
                                      <form #form="ngForm" class="addpaynow">
                                        <div class="form-group formgroup-tm">
                      
                                          <div class="row pt-2">
                      
                                             
                                            
                                            <div class="col-md-12">
                                             
                                              <div class="form-group formgroup-tm">
                                                <label class="customlabel">Business Name* </label>
                                                <input class="formcontrol-user1 form-control"   type="text" placeholder="Business Name*" id="BusinessName" name="BusinessName"
                                                  [formControl]="BusinessName" required>
                      
                                              </div>
                                              <span class="text-danger" *ngIf="BusinessName.invalid && (BusinessName.dirty || BusinessName.touched)">{{bussinessNameError()}}</span>
                      
                      
                                            </div>
                                          </div>


                                          <div class="row pt-2"> 
                                            
                                            <div class="col-md-12">
                                             
                                              <div class="form-group formgroup-tm">
                                                <label class="customlabel">Business Owner Name* </label>
                                                <input class="formcontrol-user1 form-control"   type="text" placeholder="Business Owner Name*" id="OwnerName" name="OwnerName"
                                                  [(ngModel)]="rows.BusinessOwnerName" [formControl]="OwnerName" (keydown)="onKey()" required>
                                              </div>
                                              <span class="text-danger"
                                                *ngIf="OwnerName.invalid && (OwnerName.dirty || OwnerName.touched)">{{OwnerNameError()}}</span>
                      
                                            </div>
                                          </div>


                                          <div class="row pt-2"> 
                                            
                                            <div class="col-md-12">
                                              
                                              <div class="form-group formgroup-tm">
                                                <label class="customlabel">Industry Type
                                                </label>
                                                <div class="selectcustom mb-0">
                                                  <ngx-select [items]="IndustryTypelist" placeholder="Industry Type" id="IndustryType" name="IndustryType"
                                                  [formControl]="IndustryType" ngModel="IType" (blur)="SelectIndustrySubType()">
                                                </ngx-select>
                                                </div>
                                                
                                                <!-- <input type="text" placeholder="Time Zone"    id="TimeZone" name="TimeZone"  [formControl]="TimeZone"> -->
                                                <!-- <mat-error *ngIf="manager.invalid">{{managererrors()}}</mat-error> -->
                                              </div>
                      
                                            </div>
                                          </div>
                                          <div class="row pt-2"> 
                                            
                                            <div class="col-md-12">
                                              
                                              <div class="form-group formgroup-tm">
                                                <label class="customlabel">Industry Sub Type
                                                </label>
                                                <div class="selectcustom mb-0">
                                                  <ngx-select [items]="IndustryTsubtypelist" placeholder="Industry Sub Type" id="IndustrySubType" name="IndustrySubType"
                                                  [formControl]="IndustrySubType" ngModel="ISType">
                                                </ngx-select>
                                                </div>
                                                
                                                <!-- <input type="text" placeholder="Time Zone"    id="TimeZone" name="TimeZone"  [formControl]="TimeZone"> -->
                                                <!-- <mat-error *ngIf="manager.invalid">{{managererrors()}}</mat-error> -->
                                              </div>
                      
                                            </div>
                                          </div>


                                          <div class="row pt-2"> 
                                            
                                            <div class="col-md-12">
                                              
                                              <div class="form-group formgroup-tm">
                                                <label class="customlabel">Business Address Line1* </label>
                                                <input class="formcontrol-user1 form-control"   type="text" placeholder="Business Address Line1*" id="BusinessAddressLine1"
                                                  name="BusinessAddressLine1" [formControl]="BusinessAddressLine1" required>
                      
                                              </div>
                                              <span class="text-danger"
                                                *ngIf="BusinessAddressLine1.invalid && (BusinessAddressLine1.dirty || BusinessAddressLine1.touched)">{{BusinessAddressLine1Error()}}</span>
                      
                      
                                            </div>
                                          </div>
                                          <div class="row pt-2"> 
                                            
                                            <div class="col-md-12">
                                              
                                              <div class="form-group formgroup-tm">
                                                <label class="customlabel">Business Address Line2</label>
                                                <input class="formcontrol-user1 form-control"   type="text" placeholder="Business Address Line2" id="BusinessAddressLine2"
                                                  name="BusinessAddressLine2" [formControl]="BusinessAddressLine2">
                                              </div>
                                              <!-- <span class="text-danger" *ngIf="email.invalid && (email.dirty || email.touched)">{{Emailerrors()}}
                                                            </span> -->
                                            </div>
                                          </div>
                      
                                          <div class="row pt-2"> 
                                            
                                            <div class="col-md-12">
                                             
                                              <div class="form-group formgroup-tm">
                                                <label class="customlabel">Business Address Line3</label>
                                                <input class="formcontrol-user1 form-control"   type="text" placeholder="Business Address Line3" id="BusinessAddressLine3"
                                                  name="BusinessAddressLine3" [formControl]="BusinessAddressLine3">
                                              </div>
                                              <!-- <span class="text-danger" *ngIf="custMobileNo.invalid && (custMobileNo.dirty || custMobileNo.touched)">{{CustMobileNoerrors()}}
                                                            </span> -->
                                            </div>
                                          </div>
                                          <div class="row pt-2"> 
                                            
                                            <div class="col-md-12">
                                              
                                              <div class="form-group formgroup-tm">
                                                <label class="customlabel">Zip Code* </label>
                                                <input class="formcontrol-user1 form-control"   type="text" placeholder="Zip Code*" id="ZipCode" name="ZipCode" maxlength="6"
                                                  [formControl]="ZipCode" required (change)="Getzipcodedetails()" [(ngModel)]="rows.ZipCode">
                                                <!-- <span *ngIf="ZipCode.invalid">{{zipcodeNameError()}}</span> -->
                                              </div>
                                              <span class="text-danger"
                                                *ngIf="ZipCode.invalid && (ZipCode.dirty || ZipCode.touched)">{{zipcodeNameError()}}</span>
                                            </div>
                                          </div>
                                          <div class="row pt-2">
                      
                                          
                                            
                                            <div class="col-md-12">
                                              
                                              <div class="form-group formgroup-tm">
                                                <label class="customlabel">City* </label>
                                                <input class="formcontrol-user1 form-control"   type="text" placeholder="City*" id="City" name="City" [formControl]="City" required>
                      
                                              </div>
                                              <span class="text-danger"
                                                *ngIf="City.invalid && (City.dirty || City.touched)">{{cityNameError()}}</span>
                      
                                            </div>
                                          </div>
                      
                                          <div class="row pt-2">   
                                            
                                            <div class="col-md-12">
                                              
                                              <div class="form-group formgroup-tm">
                                                <label class="customlabel">State* </label>
                                                    <!-- <input class="formcontrol-user1 form-control"   type="text" placeholder="State*" id="State" name="State" [formControl]="State" required>
                                                     -->
                                                      <div class="selectcustom mb-0">
                                                          <ngx-select [items]="slist" placeholder="State*" id="State" name="State" [formControl]="State">
                                                             </ngx-select>
                                                      </div>
                       
                                              </div>
                                              <span class="text-danger"
                                                 *ngIf="State.invalid && (State.dirty || State.touched)">{{stateNameError()}}</span>  
                                            </div>
                                          </div>
                      
                      
                                          <div class="row pt-2"> 
                                            
                                            <div class="col-md-12">
                                              
                                              <div class="form-group formgroup-tm">
                                                <label class="customlabel">Country* </label>
                                                <input class="formcontrol-user1 form-control"  value="Indian"  type="text" placeholder="Country*" id="Country" name="Country" [formControl]="Country" [(ngModel)]="defaultcountry" 
                                                  required>
                      
                                              </div>
                                              <span class="text-danger"
                                                *ngIf="Country.invalid && (Country.dirty || Country.touched)">{{countryNameError()}}</span>
                                            </div>
                                          </div>
                      
                      
                      
                      
                                          <div class="row pt-2"> 
                                            
                                            <div class="col-md-12">
                                              
                                              <div class="form-group formgroup-tm">
                                                <label class="customlabel">Currency </label>
                                                <!-- <input class="formcontrol-user1 form-control"   type="text" placeholder="Currency"   id="Currency" name="Currency" [formControl]="Currency"> -->
                                                <ngx-select [items]="CurrencyType" placeholder="Currency" id="Currency" name="Currency"
                                                  [formControl]="Currency" [(ngModel)]="defaultcurrence" >
                                                </ngx-select>
                      
                                              </div>
                      
                                            </div>
                                          </div>
                      
                      
                                          <div class="row pt-2">
                      
                                            
                                            
                                            <!-- <div class="col-md-12">
                                              <label class="customlabel">Localization
                                              </label>
                                              <div class="form-group formgroup-tm">
                                                <input class="formcontrol-user1 form-control"   type="text" placeholder="Localization" id="Localization" name="Localization"
                                                  maxlength="6" [formControl]="Localization" required>
                      
                                              </div>
                      
                                            </div> -->
                                          </div>
                                          <div class="row pt-2"> 
                                            
                                            <div class="col-md-12">
                                              
                                              <div class="form-group formgroup-tm">
                                                <label class="customlabel">Business Logo </label>
                                                <div class="formcontrol-user1">
                                                  <input  type="file"
                                                  matTooltip="Upload file with(.jpeg/.jpg/.png/.bmp/.doc/.docx/.pdf) extensions"
                                                  id="businesslogo" multiple (change)="getFileDetails($event,2)">
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row pt-2"> 
                                            
                                            <div class="col-md-12">
                                             
                                              <div class="form-group formgroup-tm">
                                                <label class="customlabel">Merchant Banner</label>
                                                <div class="formcontrol-user1 mb-0">
                                                  <input type="file"
                                                  matTooltip="Upload file with(.jpeg/.jpg/.png/.bmp/.doc/.docx/.pdf) extensions"
                                                  id="businesslogo" multiple (change)="BannerFileDetails($event,1)">
                                                </div>
                                               
                                              </div>
                      
                                            </div>
                                          </div>
                      
                                          <div class="row pt-2"> 
                                            
                                            <div class="col-md-12">
                                              
                                              <div class="form-group formgroup-tm">
                                                <label class="customlabel">Time Zone
                                                </label>
                                                <div class="selectcustom mb-0">
                                                  <ngx-select [items]="zone" placeholder="Time Zone" id="TimeZone" name="TimeZone"
                                                  [formControl]="TimeZone" [(ngModel)]="defaulttimezone">
                                                </ngx-select>
                                                </div>
                                                
                                                <!-- <input type="text" placeholder="Time Zone"    id="TimeZone" name="TimeZone"  [formControl]="TimeZone"> -->
                                                <!-- <mat-error *ngIf="manager.invalid">{{managererrors()}}</mat-error> -->
                                              </div>
                      
                                            </div>
                                          </div>
                      
                      
                      
                      
                                          <div class="row pt-2"> 
                                            
                                            <div class="col-md-12">
                                             
                                               <div class="input-group form-group formgroup-tm prefix mb-0">
                                                <label class="customlabel">Customer Care Phone No* </label>
                                                <span class="input-group-addon" *ngIf="currency =='$'">+1</span>
                                                <span class="input-group-addon" *ngIf="currency =='₹'">+91</span>
                                                <input class="formcontrol-user1 form-control w-100"  type="tel" placeholder=" Customer Care Phone No *" maxlength="12" id="PhoneNo"
                                                  name="PhoneNo" [formControl]="PhoneNo"  [(ngModel)]="businessContactnum">
                      
                                              </div>
                                              <span class="text-danger"
                                                *ngIf="PhoneNo.invalid && (PhoneNo.dirty || PhoneNo.touched)">{{phoneerrors()}}</span>
                                                <!-- <span *ngIf="mobileerror" class="text-danger">
                                                  {{Mobileerrormessage}}
                                              </span> -->
                                              <!-- (change)="MobileValidation()" -->
                                            </div>
                                          </div>
                      
                      
                                          <div class="row pt-2"> 
                                            
                                            <div class="col-md-12">
                                              
                                              <div class="form-group formgroup-tm">
                                                <label class="customlabel">Email
                                                </label>
                                                <input class="formcontrol-user1 form-control"   type="text" placeholder="Email" id="Email" name="Email" [formControl]="Email"
                                                  pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$" [(ngModel)]="Businessemail">
                      
                                              </div>
                                              <!-- <span class="text-danger"
                                                *ngIf="Email.invalid && (Email.dirty || Email.touched)">{{Emailerrors()}}</span> -->
                                            </div>
                                          </div>
                                          <div class="row pt-2"> 
                                            
                                            <div class="col-md-12">
                                             
                                              <div class="form-group formgroup-tm">
                                                <label class="customlabel">Web Site</label>
                                                <input class="formcontrol-user1 form-control"   type="text" placeholder="Web Site" id="WebSite" name="WebSite" [formControl]="WebSite">
                      
                                              </div>
                                              <span class="text-danger"
                                                *ngIf="WebSite.invalid && (WebSite.dirty || WebSite.touched)">{{WebSiteerrors()}}</span>
                                            </div>
                                          </div>
                      
                      
                                          <div class="row pt-2"> 
                                            
                                            <div class="col-md-12">
                                             
                                              <div class="form-group formgroup-tm">
                                                <label class="customlabel">Customer Care Email
                                                </label>
                                                <input class="formcontrol-user1 form-control"   type="text" placeholder="Customer Care ContactEmail" id="CustomerContactEmail"
                                                  name="CustomerContactEmail" [formControl]="CustomerContactEmail"
                                                  pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$">
                                              </div>
                                              <!-- <span class="text-danger"
                                                *ngIf="CustomerContactEmail.invalid && (CustomerContactEmail.dirty || CustomerContactEmail.touched)">{{customerEmailerrors()}}</span> -->
                                            </div>
                                          </div>

                                          <div class="row pt-2"> 
                                            <div class="col-md-12">
                                              <label>Enable WhatsApp</label>
                                              <div>
                                                <input type="checkbox" id="customerWhatsappNumber" name="customerWhatsappNumber" (click)="onKey()"
                                                  [(ngModel)]="customerWhatsappNumber" (click)="enableWhatsapp()" />
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row pt-2" *ngIf="whatsappNumber"> 
                                            <div class="col-md-12">
                                              <div class="input-group form-group formgroup-tm prefix">
                                                <label class="customlabel"> Customer Care whatsApp Number  </label>
                                                <span class="input-group-addon" *ngIf="currency =='$'">+1</span>
                                                <span class="input-group-addon" *ngIf="currency =='₹'">+91</span>
                                                <input class="formcontrol-user1 form-control w-100"  type="tel" placeholder="Customer Care Phone No " (keydown)="onKey()" id="Customercarewhatsapp"
                                                  name="PhoneNo" maxlength="12" [formControl]="Customercarewhatsapp" [(ngModel)]="rows.CustomerCareWhatsupNumber" required>
                                              </div>
                                              <span class="text-danger"
                                                *ngIf="PhoneNo.invalid && (PhoneNo.dirty || PhoneNo.touched)">{{phoneerrors()}}</span>
                                            </div>
                                          </div>
                      
                                          <div class="row pt-2"> 
                                            
                                            <div class="col-md-12">
                                              <label >EnableOnlineStore
                                              </label>
                                              <div>
                                                <input  type="checkbox" id="OnlineStore" name="EnableOnlineStore" (click)="showhide()" />
                                              </div>
                                            </div>
                                          </div>

                                          <div class="row pt-2"> 
                                            <div class="col-md-12">
                                              <label>Enable WhatsApp</label>
                                              <div>
                                                <input type="checkbox" id="customerWhatsappNumber" name="customerWhatsappNumber" (click)="onKey()"
                                                  [(ngModel)]="customerWhatsappNumber" (click)="enableWhatsapp()" />
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row pt-2" *ngIf="whatsappNumber"> 
                                            <div class="col-md-12">
                                              <div class="input-group form-group formgroup-tm prefix">
                                                <label class="customlabel"> Customer Care whatsApp Number  </label>
                                                <span class="input-group-addon" *ngIf="currency =='$'">+1</span>
                                                <span class="input-group-addon" *ngIf="currency =='₹'">+91</span>
                                                <input class="formcontrol-user1 form-control w-100"  type="tel" placeholder="Customer Care Phone No " (keydown)="onKey()" id="Customercarewhatsapp"
                                                  name="PhoneNo" maxlength="12" [formControl]="Customercarewhatsapp" [(ngModel)]="rows.CustomerCareWhatsupNumber" required>
                                              </div>
                                              <span class="text-danger"
                                                *ngIf="PhoneNo.invalid && (PhoneNo.dirty || PhoneNo.touched)">{{phoneerrors()}}</span>
                                            </div>
                                          </div>
                      
                                          <!-- <div class="row pt-2"> 
                                            
                                            <div class="col-md-12">
                                              <label class="customlabel">OnlineStoreKey
                                              </label>
                                              <div class="form-group formgroup-tm">
                                                <input class="formcontrol-user1 form-control"   type="text" placeholder="Online StoreKey" id="OnlineStoreKey" name="OnlineStoreKey"
                                                  [formControl]="OnlineStoreKey">
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row pt-2"> 
                                            
                                            <div class="col-md-12">
                                              <label class="customlabel">Online StoreDomain Url
                                              </label>
                                              <div class="form-group formgroup-tm">
                                                <input class="formcontrol-user1 form-control"   type="text" placeholder="Online StoreDomain Url" id="OnlineStoreDomainUrl"
                                                  name="OnlineStoreDomainUrl" [formControl]="OnlineStoreDomainUrl">
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row pt-2"> 
                                            
                                            <div class="col-md-12">
                                              <label class="customlabel">Business Geo Location
                                              </label>
                                              <div class="form-group formgroup-tm">
                                                <input class="formcontrol-user1 form-control"   type="text" placeholder="Business Geo Location" id="BusinesGeoLocation"
                                                  name="BusinesGeoLocation" [formControl]="BusinesGeoLocation">
                                              </div>
                                            </div>
                                          </div> -->
                      
                      
                                          <div class="row pt-2" *ngIf="OnlineTemplate">
                                            
                                            <div class="col-md-12">
                                             
                                              <div class="form-group formgroup-tm">
                                                <label class="customlabel"> Online Store Template*
                                                </label>
                                                <div class="selectcustom mb-0">
                                                  <ngx-select [items]="TemplateType" id="Type" placeholder="Type *" [formControl]="Type"
                                                  >
                                                </ngx-select>
                                                </div>
                                              </div>
                                              <!-- <span class="text-danger"
                                                *ngIf="Type.invalid && (Type.dirty || Type.touched)">{{Typeerrors()}}</span> -->
                                            </div>
                                          </div>
                      
                      
                                          <div class="text-right pt-3">
                                            <button class="btn dash-btns" type="button" id="Businessinfo" color="primary"
                                            [disabled]="BusinessName.invalid||BusinessAddressLine1.invalid||City.invalid||State.invalid ||ZipCode.invalid ||Country.invalid||PhoneNo.invalid ||WebSite.invalid||OnlineStoreDomainUrl.invalid||domainerror"
                                              (click)="newBusinessInfo()">Submit</button>
                      
                                          </div>
                      
                                        </div>
                                      </form>
                                    </div>
                                    <div class="col-md-12" *ngIf="isUpdateBusinessinfo">
                                      <form #form="ngForm" class="addpaynow">
                                        <div class="form-group formgroup-tm">
                      
                                          <div class="row pt-2"> 
                                            
                                            <div class="col-md-12">
                                             
                                              <div class="form-group formgroup-tm">
                                                <label class="customlabel">Business Name* </label>
                                                <input class="formcontrol-user1 form-control"   type="text" placeholder="Business Name*" id="BusinessName" name="BusinessName"
                                                  [(ngModel)]="rows.BusinessName" [formControl]="BusinessName" (keydown)="onKey()" required>
                                              </div>
                                              <span class="text-danger"
                                                *ngIf="BusinessName.invalid && (BusinessName.dirty || BusinessName.touched)">{{bussinessNameError()}}</span>
                      
                                            </div>
                                          </div>


                                          <div class="row pt-2"> 
                                            
                                            <div class="col-md-12">
                                             
                                              <div class="form-group formgroup-tm">
                                                <label class="customlabel">Business Owner Name* </label>
                                                <input class="formcontrol-user1 form-control"   type="text" placeholder="Business Owner Name*" [(ngModel)]="rows.BusinessOwnerName" id="OwnerName" name="OwnerName"
                                                  [formControl]="OwnerName"  required>
                                              </div>
                                              
                                              <span class="text-danger"
                                                *ngIf="OwnerName.invalid && (OwnerName.dirty || OwnerName.touched)">{{OwnerNameError()}}</span>
                      
                                            </div>
                                          </div>

                                          <div class="row pt-2"> 
                                            
                                            <div class="col-md-12">
                                              
                                              <div class="form-group formgroup-tm">
                                                <label class="customlabel">Industry Type
                                                </label>
                                                <div class="selectcustom mb-0">
                                                  <ngx-select [items]="IndustryTypelist" placeholder="Industry Type" id="IndustryType" name="IndustryType"
                                                  [formControl]="IndustryType" [(ngModel)]="rows.IndustryType" (blur)="SelectIndustrySubType()" (select)="onKey()">
                                                </ngx-select>
                                                </div>
                                                
                                                <!-- <input type="text" placeholder="Time Zone"    id="TimeZone" name="TimeZone"  [formControl]="TimeZone"> -->
                                                <!-- <mat-error *ngIf="manager.invalid">{{managererrors()}}</mat-error> -->
                                              </div>
                      
                                            </div>
                                          </div>


                                          <div class="row pt-2"> 
                                            
                                            <div class="col-md-12">
                                              
                                              <div class="form-group formgroup-tm">
                                                <label class="customlabel">Industry Sub Type
                                                </label>
                                                <div class="selectcustom mb-0">
                                                  <ngx-select [items]="IndustryTsubtypelist" placeholder="Industry Sub Type" id="IndustrySubType" name="IndustrySubType"
                                                  [formControl]="IndustrySubType" [(ngModel)]="rows.IndustrySubType" (select)="onKey()">
                                                </ngx-select>
                                                </div>
                                                
                                                <!-- <input type="text" placeholder="Time Zone"    id="TimeZone" name="TimeZone"  [formControl]="TimeZone"> -->
                                                <!-- <mat-error *ngIf="manager.invalid">{{managererrors()}}</mat-error> -->
                                              </div>
                      
                                            </div>
                                          </div>
                                        
                                          <div class="row pt-2"> 
                                            
                                            <div class="col-md-12">
                                              
                                              <div class="form-group formgroup-tm">
                                                <label class="customlabel">Business Address Line1* </label>
                                                <input class="formcontrol-user1 form-control"   type="text" placeholder="Business Address Line1*" (keydown)="onKey()"
                                                  id="BusinessAddressLine1" name="BusinessAddressLine1"
                                                  [(ngModel)]="rows.BusinessAddressLine1" [formControl]="BusinessAddressLine1" required>
                                              </div>
                                              <span class="text-danger"
                                                *ngIf="BusinessAddressLine1.invalid && (BusinessAddressLine1.dirty || BusinessAddressLine1.touched)">{{BusinessAddressLine1Error()}}</span>
                      
                                            </div>
                                          </div>
                                          <div class="row pt-2"> 
                                            
                                            <div class="col-md-12">
                                             
                                              <div class="form-group formgroup-tm">
                                                <label class="customlabel">Business Address Line2</label>
                                                <input class="formcontrol-user1 form-control" type="text" placeholder="Business Address Line2" (keydown)="onKey()"
                                                  id="BusinessAddressLine2" name="BusinessAddressLine2"
                                                  [(ngModel)]="rows.BusinessAddressLine2" [formControl]="BusinessAddressLine2">
                                              </div>
                                              <!-- <span class="text-danger" *ngIf="email.invalid && (email.dirty || email.touched)">{{Emailerrors()}}
                                                            </span> -->
                                            </div>
                                          </div>
                      
                                          <div class="row pt-2"> 
                                            
                                            <div class="col-md-12">
                                              
                                              <div class="form-group formgroup-tm">
                                                <label class="customlabel">Business Address Line3</label>
                                                <input class="formcontrol-user1 form-control"   type="text" placeholder="Business Address Line3" (keydown)="onKey()"
                                                  id="BusinessAddressLine3" name="BusinessAddressLine3" [formControl]="BusinessAddressLine3"
                                                  [(ngModel)]="rows.BusinessAddressLine3">
                                              </div>
                                              <!-- <span class="text-danger" *ngIf="custMobileNo.invalid && (custMobileNo.dirty || custMobileNo.touched)">{{CustMobileNoerrors()}}
                                                            </span> -->
                                            </div>
                                          </div>
                                          <div class="row pt-2"> 
                                            
                                            <div class="col-md-12">
                                              
                                              <div class="form-group formgroup-tm">
                                                <label class="customlabel">Zip Code* </label>
                                                <input class="formcontrol-user1 form-control"   type="text" placeholder="Zip Code*" id="ZipCode" name="ZipCode" maxlength="6"
                                                  [formControl]="ZipCode"  [(ngModel)]="rows.ZipCode" required (change)="Getzipcodedetails()">
                                                <!-- <span *ngIf="ZipCode.invalid">{{zipcodeNameError()}}</span> -->
                                              </div>
                                              <span class="text-danger"
                                                *ngIf="ZipCode.invalid && (ZipCode.dirty || ZipCode.touched)">{{zipcodeNameError()}}</span>
                                            </div>
                                          </div>
                                          <div class="row pt-2"> 
                                            <div class="col-md-12">
                                              
                                              <div class="form-group formgroup-tm">
                                                <label class="customlabel">City *</label>
                                                <input class="formcontrol-user1 form-control"   type="text" placeholder="City*" id="City" name="City" (keydown)="onKey()"
                                                  [formControl]="City" [(ngModel)]="Pcity" required>
                                              </div>
                                              <span class="text-danger"
                                                *ngIf="City.invalid && (City.dirty || City.touched)">{{cityNameError()}}</span>
                      
                                            </div>
                                          </div>
                      
                                          <div class="row pt-2"> 
                                            
                                            <div class="col-md-12">
                                             
                                              <div class="form-group formgroup-tm">
                                                <!-- <input class="formcontrol-user1 form-control"   type="text" placeholder="State*" id="State" name="State" (select)="onKey()"
                                                  [(ngModel)]="rows.state" [formControl]="State" required> -->
                                                  <label class="customlabel">State *</label>
                                                  <div class="selectcustom mb-0">
                                                    <ngx-select [items]="slist" placeholder="State*" [(ngModel)]="PState"
                                                    id="State" name="State" [formControl]="State" (select)="onKey()">
                                                  </ngx-select>
                                                  </div>
                                            


                                              </div>
                                              <span class="text-danger"
                                                *ngIf="State.invalid && (State.dirty || State.touched)">{{stateNameError()}}</span>
                                            </div>
                                          </div>
                      
                      
                      
                      
                                          <div class="row pt-2"> 
                                            
                                            <div class="col-md-12">
                                           
                                              <div class="form-group formgroup-tm">
                                                <label class="customlabel">Country *</label>
                                                <input class="formcontrol-user1 form-control"   type="text" placeholder="Country" id="Country" name="Country" (keydown)="onKey()"
                                                  [formControl]="Country" [(ngModel)]="PCountry" required>
                      
                                              </div>
                                              <span class="text-danger"
                                                *ngIf="Country.invalid && (Country.dirty || Country.touched)">{{countryNameError()}}</span>
                                            </div>
                                          </div>
                      
                      
                      
                      
                                          <div class="row pt-2"> 
                                            
                                            <div class="col-md-12">
                                             
                                              <div class="form-group formgroup-tm">
                                                <label class="customlabel">Currency </label>
                                                <!-- <input type="text" placeholder="Currency"   id="Currency" name="Currency" [formControl]="Currency" [(ngModel)]="rows.currency"> -->
                                                <div class="selectcustom mb-0">
                                                  <ngx-select [items]="CurrencyType" placeholder="Currency" id="Currency" (select)="onKey()"
                                                  name="Currency" [formControl]="Currency" [(ngModel)]="rows.Currency">
                                                </ngx-select>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                      
                      
                      
                                          <div class="row pt-2"> 
                                            
                                            <div class="col-md-12">
                                             
                                              <div class="form-group formgroup-tm">
                                                <label class="customlabel">Business Logo</label>
                                                <div class="formcontrol-user1 mb-0">
                                                  <input type="file"
                                                  matTooltip="Upload file with(.jpeg/.jpg/.png/.bmp/.doc/.docx/.pdf) extensions"
                                                  id="businesslogo" multiple (change)="getFileDetails($event,2)">
                                                </div>
                                               
                                              </div>
                      
                                            </div>
                                          </div>


                                          <div class="row pt-2"> 
                                            
                                            <div class="col-md-12">
                                             
                                              <div class="form-group formgroup-tm">
                                                <label class="customlabel">Merchant Banner</label>
                                                <div class="formcontrol-user1 mb-0">
                                                  <input type="file"
                                                  matTooltip="Upload file with(.jpeg/.jpg/.png/.bmp/.doc/.docx/.pdf) extensions"
                                                  id="businesslogo" multiple (change)="BannerFileDetails($event,1)">
                                                </div>
                                               
                                              </div>
                      
                                            </div>
                                          </div>
                                          
                      
                      
                      
                                          <!-- <div class="row pt-2"> 
                                            
                                            <div class="col-md-12">
                                              <label class="customlabel">Localization
                                              </label>
                                              <div class="form-group formgroup-tm">
                                                <input class="formcontrol-user1 form-control"   type="text" placeholder="Localization" id="Localization" (keydown)="onKey()"
                                                  name="Localization" maxlength="6" [formControl]="Localization"
                                                  [(ngModel)]="rows.localization" required>
                      
                                              </div>
                      
                                            </div>
                                          </div> -->
                                          <!-- <div class="row pt-2">
                            
                                        <div class="col-md-5 col-lg-4">
                                          <label class="customlabel">Business Logo
                                            <span
                                                  class="text-danger">*</span></label>
                                      </div>
                                       
                                        <div class="col-md-12">
                                          <div class="form-group formgroup-tm"> 
                                              <input type="text" placeholder="Business Logo"    id="BusinessLogo" name="BusinessLogo"  [formControl]="BusinessLogo" [(ngModel)]="rows.businessLogo">
                                                    </div>
                                         
                                      </div>
                                  </div> -->
                      
                                          <div class="row pt-2"> 
                                            
                                            <div class="col-md-12">
                                  
                                              <div class="form-group formgroup-tm">
                                                <label class="customlabel">Time Zone
                                                </label>
                                                <div class="selectcustom mb-0">
                                                  <ngx-select [items]="zone" placeholder="Time Zone" (select)="onKey()" id="TimeZone"
                                                  name="TimeZone" [formControl]="TimeZone" [(ngModel)]="rows.TimeZone">
                                                </ngx-select>
                                                </div>
                                               
                                                <!-- <input type="text" placeholder="Time Zone"    id="TimeZone" name="TimeZone"  [formControl]="TimeZone" [(ngModel)]="rows.TimeZone"> -->
                                                <!-- <mat-error *ngIf="manager.invalid">{{managererrors()}}</mat-error> -->
                                              </div>
                      
                                            </div>
                                          </div>
                      
                      
                      
                      
                                          <div class="row pt-2"> 
                                            
                                            <div class="col-md-12">
                                             
                                              <div class="input-group form-group formgroup-tm prefix">
                                                <label class="customlabel"> Customer Care Phone No*  </label>
                                                <span class="input-group-addon" *ngIf="currency =='$'">+1</span>
                                                <span class="input-group-addon" *ngIf="currency =='₹'">+91</span>
                                                <input class="formcontrol-user1 form-control w-100"  type="tel" placeholder="Customer Care Phone No " (keydown)="onKey()" id="PhoneNo"
                                                  name="PhoneNo" maxlength="12" [formControl]="PhoneNo" [(ngModel)]="rows.PhoneNo">
                      
                                              </div>
                                              <span class="text-danger"
                                                *ngIf="PhoneNo.invalid && (PhoneNo.dirty || PhoneNo.touched)">{{phoneerrors()}}</span>
                                                <!-- <span *ngIf="mobileerror" class="text-danger">
                                                  {{Mobileerrormessage}}
                                              </span> -->
                                              <!-- (change)="MobileValidation()" -->
                                            </div>
                                          </div>
                      
                      
                                          <div class="row pt-2"> 
                                            
                                            <div class="col-md-12">
                                          
                                              <div class="form-group formgroup-tm">
                                                <label class="customlabel">Email </label>
                                                <input class="formcontrol-user1 form-control"   type="text" placeholder="Email " id="Email" name="Email" [formControl]="Email"
                                                  (keydown)="onKey()" [(ngModel)]="rows.Email"
                                                  pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$">
                                                <!-- <mat-error *ngIf="Email.invalid">{{Emailerrors()}}</mat-error> -->
                                              </div>
                      
                                            </div>
                                          </div>
                                          <div class="row pt-2"> 
                                            
                                            <div class="col-md-12">
                                              
                                              <div class="form-group formgroup-tm">
                                                <label class="customlabel">Web Site </label>
                                                <input class="formcontrol-user1 form-control"   type="text*" placeholder="Web Site" (keydown)="onKey()" id="WebSite" name="WebSite"
                                                  [formControl]="WebSite" [(ngModel)]="rows.WebSite">
                      
                                              </div>
                                              <span class="text-danger"
                                                *ngIf="WebSite.invalid && (WebSite.dirty || WebSite.touched)">{{WebSiteerrors()}}</span>
                      
                      
                                            </div>
                                          </div>
                      
                      
                                          <div class="row pt-2"> 
                                            
                                            <div class="col-md-12">
                                             
                                              <div class="form-group formgroup-tm">
                                                <label class="customlabel">Customer Care Email
                                                </label>
                                                <input class="formcontrol-user1 form-control"   type="text" placeholder="Customer Care ContactEmail" (keydown)="onKey()"
                                                  id="CustomerContactEmail" name="CustomerContactEmail"
                                                  [(ngModel)]="rows.CustomerContactEmail" [formControl]="CustomerContactEmail"
                                                  pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$">
                      
                                              </div>
                                              <!-- <span class="text-danger"
                                                *ngIf="CustomerContactEmail.invalid && (CustomerContactEmail.dirty || CustomerContactEmail.touched)">{{customerEmailerrors()}}</span> -->
                                            </div>
                                          </div>
                      
                      
                      
                                          <div class="row pt-2"> 
                                            
                                            <div class="col-md-12">
                                              <label>EnableOnlineStore  </label>
                                              <div>
                                                <input     type="checkbox" id="OnlineStore" name="EnableOnlineStore" (click)="onKey()"
                                                  [(ngModel)]="onlineStoreurl" (click)="showhide()" />
                                              </div>
                                            </div>
                                          </div>
                      
                                          <!-- <div class="row pt-2"> 
                                            
                                            <div class="col-md-12">
                                              <label class="customlabel">OnlineStoreKey
                                              </label>
                                              <div class="form-group formgroup-tm">
                                                <input class="formcontrol-user1 form-control"   type="text" placeholder="Online StoreKey" [(ngModel)]="rows.onlineStoreKey"
                                                  (keydown)="onKey()" id="OnlineStoreKey" name="OnlineStoreKey"
                                                  [formControl]="OnlineStoreKey">
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row pt-2"> 
                                            
                                            <div class="col-md-12">
                                              <label class="customlabel">Online StoreDomain Url  </label>
                                              <div class="form-group formgroup-tm">
                                                <input class="formcontrol-user1 form-control"   type="text" placeholder="Online StoreDomain Url"
                                                  [(ngModel)]="rows.onlineStoreDomainUrl" (keydown)="onKey()" id="OnlineStoreDomainUrl"
                                                  name="OnlineStoreDomainUrl" [formControl]="OnlineStoreDomainUrl" maxlength="25"  (change)="checkDomainurl()" pattern="[^\s]*">
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row pt-2"> 
                                            
                                            <div class="col-md-12">
                                              <label class="customlabel">Business Geo Location
                                              </label>
                                              <div class="form-group formgroup-tm">
                                                <input class="formcontrol-user1 form-control"   type="text" placeholder="Business Geo Location" [(ngModel)]="rows.businesGeoLocation"
                                                  id="BusinesGeoLocation" name="BusinesGeoLocation" [formControl]="BusinesGeoLocation">
                                              </div>
                                            </div>
                                          </div>
                       -->
                      
                      
                      
                      
                      
                       <div class="row pt-2"> 
                                            
                        <div class="col-md-12">
                          <label class="customlabel">Online StoreDomain Url  </label>
                          <div class="form-group formgroup-tm">
                            <input class="formcontrol-user1 form-control"   type="text" placeholder="Online StoreDomain Url"
                              [(ngModel)]="rows.OnlineStoreDomainUrl" (keydown)="onKey()" id="OnlineStoreDomainUrl"
                              name="OnlineStoreDomainUrl" [formControl]="OnlineStoreDomainUrl" maxlength="25"  (change)="checkDomainurl()" pattern="[^\s]*">
                          </div>
                        </div>
                      </div>
                      
                      
                      

                      
                                          <div class="row pt-2" *ngIf="OnlineTemplate"> 
                                            
                                            <div class="col-md-12">
                                              
                                              <div class="form-group formgroup-tm">
                                                <label class="customlabel"> Online Store Template
                                                </label>
                                                <div class="selectcustom mb-0">
                                                  <ngx-select [items]="TemplateType" id="Type" placeholder="Type" (select)="onKey()"
                                                  [(ngModel)]="rows.OnlineStoreTemplate" [formControl]="Type" required>
                                                </ngx-select>
                      
                                                </div>
                                               
                                              </div>
                                              <!-- <span class="text-danger"
                                                *ngIf="Type.invalid && (Type.dirty || Type.touched)">{{Typeerrors()}}</span> -->
                                            </div>
                                          </div>
                                            
                                          <div class="row mb-3">
                                            <div class="col-4 p-0"><label>Merchant Banner</label></div>
                                             
                                            <div class="col-7 view-text" *ngIf="Bannerlogo">
                        
                                              <img [ngStyle]="{'width': maxWidth+'px', 'height': maxHeight+'px'}"
                                                src="data:image/jpeg;base64,{{Blogo}}" fxFlexAlign="center" id="merchatImage"
                                                class="fade-in-on-icon-sidenav img-thumbnail img-rounded">
                        
                                            </div>
                                            <div class="col-7 view-text" *ngIf="noBannerlogo">
                        
                                              <img [ngStyle]="{'width': maxWidth+'px', 'height': maxHeight+'px'}"
                                                src="assets/img/no-preview.png" fxFlexAlign="center" id="merchatImage"
                                                class="fade-in-on-icon-sidenav img-thumbnail img-rounded">
                        
                                            </div>
                                          </div>


                      
                                          <div class="text-right py-2">
                                            <button class="btn dash-btns" type="button" id="Businessinfo" color="primary"
                                            [disabled]="BusinessName.invalid||BusinessAddressLine1.invalid||City.invalid||State.invalid ||ZipCode.invalid ||Country.invalid||PhoneNo.invalid || !isReadytoUpdatebusinesinfo||WebSite.invalid||OnlineStoreDomainUrl.invalid||domainerror"
                                              (click)="updateBusinessInfo()">Update</button>
                                            <!-- [disabled]="BusinessName.invalid||BusinessAddressLine1.invalid||City.invalid||State.invalid ||ZipCode.invalid ||Country.invalid||PhoneNo.invalid || Email.invalid || CustomerContactEmail.invalid||Type.invalid ||WebSite.invalid" -->
                                            <!-- [disabled]="BusinessName.invalid||BusinessAddressLine1.invalid||City.invalid||State.invalid ||ZipCode.invalid ||Country.invalid||PhoneNo.invalid || Email.invalid || CustomerContactEmail.invalid" -->
                                          </div>
                      
                                        </div>
                                      </form>
                                    </div>
                                    <div class="col-md-12" *ngIf="businessviewinfo">
                                      <div>
                                        <div class="row mb-3">
                                          <div class="col-4 p-0"><label>Business Name</label></div>
                                           
                                          <div class="col-7 view-text"> {{rows.BusinessName}}</div>
                                        </div>
                                        <div class="row mb-3">
                                          <div class="col-4 p-0"><label>Business Owner Name</label></div>
                                           
                                          <div class="col-7 view-text"> {{rows.BusinessOwnerName}}</div>
                                        </div>
                                        <div class="row mb-3">
                                          <div class="col-4 p-0"><label>Business AddressLine1</label></div>
                                           
                                          <div class="col-7 view-text">{{rows.BusinessAddressLine1}}</div>
                                        </div>
                                        <div class="row mb-3">
                                          <div class="col-4 p-0"> <label>Business AddressLine2 </label></div>
                                           
                                          <div class="col-7 view-text"> {{rows.BusinessAddressLine2}}</div>
                                        </div>
                      
                      
                                        <div class="row mb-3">
                                          <div class="col-4 p-0"><label>Business AddressLine3</label> </div>
                                           
                                          <div class="col-7 view-text"> {{ rows.BusinessAddressLine3}}</div>
                                        </div>
                                        <div class="row mb-3">
                                          <div class="col-4 p-0"><label> City</label></div>
                                           
                                          <div class="col-7 view-text"> {{rows.City }}</div>
                                        </div>
                                        <div class="row mb-3">
                                          <div class="col-4 p-0"><label>State</label></div>
                                           
                                          <div class="col-7 view-text"> {{rows.State}}</div>
                                        </div>
                                        <div class="row mb-3">
                                          <div class="col-4 p-0"><label>ZipCode</label></div>
                                           
                                          <div class="col-7 view-text"> {{rows.zipCode}}</div>
                                        </div>
                                        <div class="row mb-3">
                                          <div class="col-4 p-0"><label>Country</label></div>
                                           
                                          <div class="col-7 view-text"> {{rows.Country}}</div>
                                        </div>
                                        <div class="row mb-3">
                                          <div class="col-4 p-0"><label>Currency</label></div>
                                           
                                          <div class="col-7 view-text"> {{rows.Currency}}</div>
                                        </div>
                                        <!-- <div class="row mb-3">
                                          <div class="col-4 p-0"><label>Localization</label></div>
                                           
                                          <div class="col-7 view-text"> {{rows.localization}}</div>
                                        </div> -->
                                        <!-- <div class="row mb-3">
                                                <div class="col-4 p-0">BusinessLogo</div>
                                                 
                                                <div class="col-7 view-text"> {{rows.businessLogo}}</div>
                                            </div> -->
                                        <div class="row mb-3">
                                          <div class="col-4 p-0"><label>TimeZone</label></div>
                                           
                                          <div class="col-7 view-text"> {{rows.TimeZone}}</div>
                                        </div>
                                        <div class="row mb-3">
                                          <div class="col-4 p-0"><label>PhoneNo</label></div>
                                           
                                          <div class="col-7 view-text"> {{rows.PhoneNo}}</div>
                                        </div>
                                        <div class="row mb-3">
                                          <div class="col-4 p-0"><label>Email</label></div>
                                           
                                          <div class="col-7 view-text"> {{rows.Email}}</div>
                                        </div>
                                        <div class="row mb-3">
                                          <div class="col-4 p-0"><label>WebSite</label></div>
                                           
                                          <div class="col-7 view-text"> {{rows.WebSite}}</div>
                                        </div>
                                        <div class="row mb-3">
                                          <div class="col-4 p-0"><label>Customer ContactEmail</label></div>
                                           
                                          <div class="col-7 view-text"> {{rows.customerContactEmail}}</div>
                                        </div>
                                        <div class="row mb-3">
                                          <div class="col-4 p-0"><label>Industry Type</label></div>
                                           
                                          <div class="col-7 view-text"> {{rows.IndustryType}}</div>
                                        </div>
                                        <div class="row mb-3">
                                          <div class="col-4 p-0"><label>Industry SubType</label></div>
                                           
                                          <div class="col-7 view-text"> {{rows.IndustrySubType}}</div>
                                        </div>
                                        <!-- <div class="row mb-3">
                                          <div class="col-4 p-0"><label>Online StoreKey</label></div>
                                           
                                          <div class="col-7 view-text"> {{rows.onlineStoreKey}}</div>
                                        </div>
                                        <div class="row mb-3">
                                          <div class="col-4 p-0"><label>Online StoreDomainUrl</label></div>
                                           
                                          <div class="col-7 view-text"> {{rows.onlineStoreDomainUrl}}</div>
                                        </div> -->
                                        <!-- <div class="row mb-3">
                                          <div class="col-4 p-0"><label>Business GeoLocation</label></div>
                                           
                                          <div class="col-7 view-text"> {{rows.businesGeoLocation}}</div>
                                        </div> -->
                                        <div class="row mb-3" *ngIf="storeurl">
                                          <div class="col-4 p-0"><label>Online Store Url</label></div>
                                           
                                          <div class="col-7 view-text"> <a href="{{Onlinestoreurl}}">{{Onlinestoreurl}}</a></div>
                                        </div>
                      
                                        <div class="row mb-3">
                                          <div class="col-4 p-0"><label>Business Logo </label></div>
                                           
                                          <div class="col-7 view-text" *ngIf="ifBlogo">
                      
                                            <img [ngStyle]="{'width': maxWidth+'px', 'height': maxHeight+'px'}"
                                              src="data:image/jpeg;base64,{{content}}" fxFlexAlign="center" id="merchatImage"
                                              class="fade-in-on-icon-sidenav img-thumbnail img-rounded">
                      
                                          </div>
                                          <div class="col-7 view-text" *ngIf="ifnoBlogo">
                      
                                            <img [ngStyle]="{'width': maxWidth+'px', 'height': maxHeight+'px'}"
                                              src="assets/img/no-preview.png" fxFlexAlign="center" id="merchatImage"
                                              class="fade-in-on-icon-sidenav img-thumbnail img-rounded">
                      
                                          </div>
                                        </div>
                                        <div class="row mb-3">
                                          <div class="col-4 p-0"><label>Merchant Banner</label></div>
                                           
                                          <div class="col-7 view-text" *ngIf="Bannerlogo">
                      
                                            <img [ngStyle]="{'width': maxWidth+'px', 'height': maxHeight+'px'}"
                                              src="data:image/jpeg;base64,{{Blogo}}" fxFlexAlign="center" id="merchatImage"
                                              class="fade-in-on-icon-sidenav img-thumbnail img-rounded">
                      
                                          </div>
                                          <div class="col-7 view-text" *ngIf="noBannerlogo">
                      
                                            <img [ngStyle]="{'width': maxWidth+'px', 'height': maxHeight+'px'}"
                                              src="assets/img/no-preview.png" fxFlexAlign="center" id="merchatImage"
                                              class="fade-in-on-icon-sidenav img-thumbnail img-rounded">
                      
                                          </div>
                                        </div>
                                        <div class="text-right py-2">
                      
                                          <button class="btn dash-btns" type="button" id="Businessinfoview" color="primary"
                                            (click)="Updatedetails()">Edit</button>
                      
                                        </div>
                                      </div>
                                    </div> 
                                  </div>
                                </form>

                            


                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="col-md-5">
                <div class="card-1">
                  <img src="https://fastswiff.com/assets/img/vpos-tour-images/payout/manage-payout.png" class="w-100" alt="">
                </div>
              </div>
          </div>
      </div>
  </section>

</div>


 